"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs2/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));

var _promise = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/promise"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _config = _interopRequireDefault(require("../../../../../targets/cord_eurofh_teams/config.js"));

var _BuildConstants = require("../../../../utils/BuildConstants");

var _HttpRequest = require("../../../../utils/HttpRequest");

var _EquizzerActions = _interopRequireDefault(require("../actions/EquizzerActions"));

var _DataStore = _interopRequireWildcard(require("../../../../KESI2/Stores/DataStore2"));

var _DataStoreComponent2 = _interopRequireDefault(require("../../DataStoreComponent/DataStoreComponent2"));

var _QuizModeChooser = require("../QuizModeChooser");

function ownKeys(object, enumerableOnly) { var keys = (0, _keys["default"])(object); if (_getOwnPropertySymbols["default"]) { var symbols = (0, _getOwnPropertySymbols["default"])(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return (0, _getOwnPropertyDescriptor["default"])(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty3["default"])(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors["default"]) { (0, _defineProperties["default"])(target, (0, _getOwnPropertyDescriptors["default"])(source)); } else { ownKeys(Object(source)).forEach(function (key) { (0, _defineProperty2["default"])(target, key, (0, _getOwnPropertyDescriptor["default"])(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

// import QuizTournament from '../QuizTournament'
var API_V1 = 'v1';
var API_V2 = 'v2';
var DEFAULT_REST_VERSION = API_V1;
var USER_PATH = 'equeoqdUser';
var USER_LEARNING_STATE_PATH = 'equeoqdUser/learningState';
var QUESTION_GET_SINGLE_PATH = 'equeoqdSinglePlay/getQuestions';
var ANSWER_POST_SINGLE_PATH = 'equeoqdSinglePlay/storeAnswer';
var ANSWER_POST_ROUND_PATH = 'equeoqdSinglePlay/storeRound';
var QUESTION_GET_ALL_OFFLINE_PATH = 'equeoqdSinglePlay/getAllQuestions';
var USER_ALL_HISTORY_PATH = 'equeoqdSinglePlay/getHistory';
var FEEDBACK_POST_PATH = 'equeoqdFeedback/sendFeedback';
var FEEDBACK_POST_PATH_QUIZZER = 'equeoqdUserFeedback/sendFeedback';
var GROUP_PATH = 'equeoqdGroup';
var GAME_PATH = 'equeoqdGame';
var QUESTION_PATH = 'equeoqdQuestion';
var RESET_PATH = 'equeoqdReset';
var LEAGUE_PATH = 'equeoqdLigaResults';
var LEARNING_DISTANCE_FEEDBACK_PATH = 'equeoqdQuestionFeedback/all';
var TOURNAMENT_LIST_PATH = 'equeoQDTournament/list';
var TOURNAMENT_SHOW_PATH = 'equeoQDTournament/show';
var TOURNAMENT_JOIN_TEAM_PATH = 'equeoQDTournament/joinTeam';
var TOURNAMENT_LEAVE_PATH = 'equeoQDTournament/leaveTournament';
var _instance = null;

function getPath(apiVersion) {
  return "rest/api/".concat(apiVersion, "/");
}

var RestService = /*#__PURE__*/function (_DataStoreComponent) {
  (0, _inherits2["default"])(RestService, _DataStoreComponent);

  var _super = _createSuper(RestService);

  function RestService(props) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, RestService);
    _this = _super.call(this, props);
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "getDataObject", /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(url, ids, userAuth) {
        var apiVersion,
            additionalParams,
            subjectId,
            path,
            params,
            serverResponse,
            _args = arguments;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                apiVersion = _args.length > 3 && _args[3] !== undefined ? _args[3] : DEFAULT_REST_VERSION;
                additionalParams = _args.length > 4 ? _args[4] : undefined;
                subjectId = _args.length > 5 && _args[5] !== undefined ? _args[5] : null;
                _context.prev = 3;
                path = "".concat(_BuildConstants.IS_KESI_APP || _config["default"].useDrupalContent ? _BuildConstants.QUIZZER_HOST : _BuildConstants.HOST, "/").concat(getPath(apiVersion)).concat(url);
                console.log("get object from ".concat(url, " and ids ").concat(ids || null, " and userAuth ").concat(userAuth, " path ").concat(path));
                params = {};

                if (ids) {
                  if (ids.length === 1) {
                    path += "/".concat(ids.toString());
                  } else if (ids.length > 1) {
                    path += "/_query";
                    params.ids = ids.toString();
                  }
                }

                if (additionalParams) {
                  params = _objectSpread(_objectSpread({}, additionalParams), params);
                }

                console.log('getDataObject', path, params, userAuth);
                _context.next = 12;
                return (0, _HttpRequest.httpGet)(path, params, null, 10000, 10, userAuth || _HttpRequest.DEFAULT_USER_AUTH);

              case 12:
                serverResponse = _context.sent;
                console.log("response to ".concat(url), serverResponse);
                return _context.abrupt("return", _promise["default"].resolve(serverResponse.data));

              case 17:
                _context.prev = 17;
                _context.t0 = _context["catch"](3);
                return _context.abrupt("return", _promise["default"].reject(_context.t0));

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 17]]);
      }));

      return function (_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }());
    (0, _defineProperty3["default"])((0, _assertThisInitialized2["default"])(_this), "postDataObject", /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(url, object, ids, update, userAuth, onQueueResponse) {
        var apiVersion,
            json,
            params,
            path,
            serverResponse,
            _args2 = arguments;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                apiVersion = _args2.length > 6 && _args2[6] !== undefined ? _args2[6] : DEFAULT_REST_VERSION;
                json = _args2.length > 7 && _args2[7] !== undefined ? _args2[7] : true;
                _context2.prev = 2;
                console.log("".concat(update ? 'put' : 'post', " object to ").concat(url, " and ids ").concat(ids, " and userAuth ").concat(userAuth));
                params = (0, _assign["default"])({}, object);
                path = "".concat(_BuildConstants.IS_KESI_APP || _config["default"].useDrupalContent ? _BuildConstants.QUIZZER_HOST : _BuildConstants.HOST, "/").concat(getPath(apiVersion)).concat(url);

                if (ids) {
                  if (ids.length === 1) {
                    path += "/".concat(ids.toString());
                  } else if (ids.length > 1) {
                    path += '/_query';
                    params.ids = ids.toString();
                  }
                }

                serverResponse = null;

                if (!json) {
                  _context2.next = 20;
                  break;
                }

                if (!update) {
                  _context2.next = 15;
                  break;
                }

                _context2.next = 12;
                return (0, _HttpRequest.httpPutJsonEncoded)(path, params, null, 10000, 10, userAuth || _HttpRequest.DEFAULT_USER_AUTH, onQueueResponse, 3500);

              case 12:
                serverResponse = _context2.sent;
                _context2.next = 18;
                break;

              case 15:
                _context2.next = 17;
                return (0, _HttpRequest.httpPostJsonEncoded)(path, params, null, 10000, 10, userAuth || _HttpRequest.DEFAULT_USER_AUTH, onQueueResponse, 3500);

              case 17:
                serverResponse = _context2.sent;

              case 18:
                _context2.next = 29;
                break;

              case 20:
                if (!update) {
                  _context2.next = 26;
                  break;
                }

                _context2.next = 23;
                return (0, _HttpRequest.httpPut)(path, params, null, 10000, 10, userAuth || _HttpRequest.DEFAULT_USER_AUTH, onQueueResponse, 3500);

              case 23:
                serverResponse = _context2.sent;
                _context2.next = 29;
                break;

              case 26:
                _context2.next = 28;
                return (0, _HttpRequest.httpPost)(path, params, null, false, 10000, 10, userAuth || _HttpRequest.DEFAULT_USER_AUTH, onQueueResponse, 3500);

              case 28:
                serverResponse = _context2.sent;

              case 29:
                console.log('Success for posting data object', update ? 'put' : 'post', url, params, ids);
                return _context2.abrupt("return", _promise["default"].resolve(serverResponse.data));

              case 33:
                _context2.prev = 33;
                _context2.t0 = _context2["catch"](2);
                console.log('Error while posting data object', update ? 'put' : 'post', _context2.t0, url, ids);
                return _context2.abrupt("return", _promise["default"].reject(_context2.t0));

              case 37:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 33]]);
      }));

      return function (_x4, _x5, _x6, _x7, _x8, _x9) {
        return _ref2.apply(this, arguments);
      };
    }());
    _this.state = {};
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(RestService.prototype)), "setDataStorePaths", _thisSuper).call(_thisSuper, [_DataStore.DATA_STORE_PATHS.QD_USER_AUTH]);
    return _this;
  }

  (0, _createClass2["default"])(RestService, null, [{
    key: "instance",
    value: function instance() {
      if (!_instance) {
        _instance = new RestService();
      }

      return _instance;
    }
  }, {
    key: "getQuestionsForCategory",
    value: function getQuestionsForCategory(rubricObj, userAuth) {
      return RestService.instance().postDataObject(QUESTION_GET_SINGLE_PATH, rubricObj, null, false, userAuth, null, API_V1, false);
    }
  }, {
    key: "getAllQuestionsForUser",
    value: function getAllQuestionsForUser(userAuth, subjectId) {
      if (subjectId) {
        return RestService.instance().getDataObject(QUESTION_GET_ALL_OFFLINE_PATH + '/' + subjectId, null, userAuth, API_V1);
      } else {
        return RestService.instance().getDataObject(QUESTION_GET_ALL_OFFLINE_PATH, null, userAuth, API_V1);
      }
    }
  }, {
    key: "getFullHistoryForUser",
    value: function getFullHistoryForUser(userAuth, subjectId) {
      if (_config["default"].useDrupalContent) {
        if (subjectId) {
          return RestService.instance().postDataObject(USER_ALL_HISTORY_PATH + '/' + subjectId, null, null, false, userAuth, null, API_V1);
        } else {
          return RestService.instance().postDataObject(USER_ALL_HISTORY_PATH, null, null, false, userAuth, null, API_V1);
        }
      } else {
        if (subjectId) {
          return RestService.instance().getDataObject(USER_ALL_HISTORY_PATH + '/' + subjectId, null, userAuth, API_V1);
        } else {
          return RestService.instance().getDataObject(USER_ALL_HISTORY_PATH, null, userAuth, API_V1);
        }
      }
    }
  }, {
    key: "getPatchForQuestions",
    value: function getPatchForQuestions(userAuth, version, subjectId) {
      if (subjectId) {
        return RestService.instance().getDataObject(QUESTION_GET_ALL_OFFLINE_PATH + '/' + subjectId + '/' + version, null, userAuth, API_V1);
      } else {
        return RestService.instance().getDataObject(QUESTION_GET_ALL_OFFLINE_PATH + '/' + version, null, userAuth, API_V1);
      }
    }
  }, {
    key: "postAnswer",
    value: function postAnswer(answerObj, userAuth) {
      return RestService.instance().postDataObject(ANSWER_POST_SINGLE_PATH, answerObj, null, false, userAuth, null, API_V1, true);
    }
  }, {
    key: "postRound",
    value: function postRound(answerObjArray, userAuth) {
      return RestService.instance().postDataObject(ANSWER_POST_ROUND_PATH, answerObjArray, null, false, userAuth, null, API_V1, true);
    }
  }, {
    key: "postUserFeedback",
    value: function postUserFeedback(feedbackObj, userAuth) {
      return RestService.instance().postDataObject(_config["default"].useDrupalContent ? FEEDBACK_POST_PATH_QUIZZER : FEEDBACK_POST_PATH, feedbackObj, null, false, userAuth, null, API_V1, false);
    }
  }]);
  return RestService;
}(_DataStoreComponent2["default"]);

(0, _defineProperty3["default"])(RestService, "getUser", function (userId, userAuth) {
  return RestService.instance().getDataObject(USER_PATH, userId, userAuth);
});
(0, _defineProperty3["default"])(RestService, "getUserLearningState", function (userAuth) {
  return RestService.instance().getDataObject(USER_LEARNING_STATE_PATH, null, userAuth);
});
(0, _defineProperty3["default"])(RestService, "getGroup", /*#__PURE__*/function () {
  var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(groupId, userAuth) {
    var subjectId,
        groupIdToUse,
        groupObject,
        playMode,
        subjectToUse,
        _args3 = arguments;
    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            subjectId = _args3.length > 2 && _args3[2] !== undefined ? _args3[2] : null;
            groupIdToUse = groupId;

            if (!groupIdToUse || groupIdToUse.length > 0 && !groupIdToUse[0]) {
              groupIdToUse = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GROUP_ID);
            }

            _context3.next = 5;
            return RestService.instance().getDataObject(GROUP_PATH, groupIdToUse, userAuth);

          case 5:
            groupObject = _context3.sent;
            playMode = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_GROUP_MODE);

            if (subjectId) {
              subjectToUse = groupObject.value.subjects.find(function (subject) {
                return subject.emsId === subjectId;
              });

              if (subjectToUse) {
                groupObject.value = _objectSpread(_objectSpread({}, groupObject.value), subjectToUse);
              }

              if (groupObject.value && groupObject.value.subjects && groupObject.value.subjects && _config["default"].deleteDuplicateSubjectUsers) {
                // in apps with a lot of users (700+ in DIHK Apps i.e.) we cant store them in two places (and we dont need them in two places because we wont switch subjects
                groupObject.value.subjects.forEach(function (subject) {
                  if (subject.users) {
                    delete subject.users;
                  }
                });
              }

              if (playMode) {
                if (playMode === _QuizModeChooser.QUIZ_PLAYMODES.BATTLE && groupObject.value.battle) {
                  groupObject.value = _objectSpread(_objectSpread({}, groupObject.value), groupObject.value.battle);
                } else if (playMode === _QuizModeChooser.QUIZ_PLAYMODES.SINGLE_PLAYER && groupObject.value.singlePlayer) {
                  groupObject.value = _objectSpread(_objectSpread({}, groupObject.value), groupObject.value.singlePlayer);
                }
              }
            }

            return _context3.abrupt("return", groupObject);

          case 9:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function (_x10, _x11) {
    return _ref3.apply(this, arguments);
  };
}());
(0, _defineProperty3["default"])(RestService, "getLeagueSeasons", function (groupId, userAuth) {
  return RestService.instance().getDataObject(LEAGUE_PATH, groupId, userAuth);
});
(0, _defineProperty3["default"])(RestService, "postPlayerImage", function (userId, userObject, userAuth) {
  return RestService.instance().postDataObject(USER_PATH, userObject, userId, true, userAuth, null);
});
(0, _defineProperty3["default"])(RestService, "getPlayerImage", function (userId, userAuth) {
  return RestService.instance().getDataObject(USER_PATH, userId, userAuth);
});
(0, _defineProperty3["default"])(RestService, "getGames", function (gameIds, userAuth) {
  return RestService.instance().getDataObject(GAME_PATH, gameIds, userAuth, API_V2);
});
(0, _defineProperty3["default"])(RestService, "getCategories", function (userAuth) {
  return RestService.instance().getDataObject(USER_LEARNING_STATE_PATH, null, userAuth, API_V1);
});
(0, _defineProperty3["default"])(RestService, "getHistoryBasedFeedback", function (userAuth) {
  return RestService.instance().getDataObject(LEARNING_DISTANCE_FEEDBACK_PATH, null, userAuth, API_V1);
});
(0, _defineProperty3["default"])(RestService, "postGame", /*#__PURE__*/function () {
  var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(gameObj, userAuth) {
    var onQueueResponse, subjectId;
    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            onQueueResponse = function onQueueResponse(response) {
              if (response.status === 200) {
                _EquizzerActions["default"].updateGameInAllGames(response.data, true);
              } else if (response.status >= 400 && response.status <= 499) {
                gameObj.isDirty = false;
                gameObj.lastUpdated = 0;

                _EquizzerActions["default"].updateGameInAllGames(gameObj, true);
              }
            };

            subjectId = _DataStore["default"].getElementByPathImmediately(_DataStore.DATA_STORE_PATHS.QD_SUBJECT_ID);

            if (subjectId) {
              gameObj.subject = subjectId;
            }

            if (!gameObj.id) {
              _context4.next = 7;
              break;
            }

            return _context4.abrupt("return", RestService.instance().postDataObject(GAME_PATH, gameObj, [gameObj.id], true, userAuth, onQueueResponse, API_V2));

          case 7:
            return _context4.abrupt("return", RestService.instance().postDataObject(GAME_PATH, gameObj, null, false, userAuth, onQueueResponse, API_V2));

          case 8:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));

  return function (_x12, _x13) {
    return _ref4.apply(this, arguments);
  };
}());
(0, _defineProperty3["default"])(RestService, "getQuestions", function (questionIds, userAuth) {
  return RestService.instance().getDataObject(QUESTION_PATH, questionIds, userAuth);
});
(0, _defineProperty3["default"])(RestService, "postReset", /*#__PURE__*/function () {
  var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(object, userAuth) {
    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return RestService.instance().postDataObject(RESET_PATH, object, null, false, userAuth);

          case 3:
            _context5.next = 8;
            break;

          case 5:
            _context5.prev = 5;
            _context5.t0 = _context5["catch"](0);
            console.warn("error logging out on server:", _context5.t0);

          case 8:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 5]]);
  }));

  return function (_x14, _x15) {
    return _ref5.apply(this, arguments);
  };
}());
var _default = RestService;
exports["default"] = _default;